import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueGtm from 'vue-gtm';
import VueRouter from 'vue-router'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueYoutube from 'vue-youtube'

Vue.use(VueYoutube)
Vue.use(BootstrapVue)
Vue.use(VueRouter)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBdpFdb_4Asuc_6-W0rg92tUIEF_MqdjeQ',
    libraries: ['places', 'geometry'], // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true
})

import Home from './components/Home.vue'
import BecomeADealer from './components/BecomeADealer.vue'
import Contact from './components/Contact.vue'
import Contacts from './components/Contacts.vue'
import Designs from './components/Designs.vue'
import Details from './components/Details.vue'
import FAQs from './components/FAQs.vue'
import Gallery from './components/Gallery.vue'
import Installation from './components/Installation.vue'
import Resources from './components/Resources.vue'
import TechnicalSpecifications from './components/TechnicalSpecifications.vue'
import WhereToBuy from './components/WhereToBuy.vue'

Vue.config.productionTip = false

const routes = [
  {
    path: '/',
    component: Home,
    meta: {
      title: 'Shower panel system for bathroom, shower and wet spaces | Wetwall',
      description: 'Investing in your bathroom is an investment in your space. Wetwall makes it easier than ever to have water-proof panels that are functionally beautiful, easy to install and offer a low cost of ownership.',
    }
  },
  {
    path: '/home',
    component: Home,
    meta: {
      title: 'Shower panel system for bathroom, shower and wet spaces | Wetwall',
      description: 'Investing in your bathroom is an investment in your space. Wetwall makes it easier than ever to have water-proof panels that are functionally beautiful, easy to install and offer a low cost of ownership.',
    }
  },
  {
    path: '/become-a-dealer',
    component: BecomeADealer,
    meta: {
      title: 'BecomeADealer | Wetwall',
      description: '',
    }
  },
  {
    path: '/contact',
    component: Contact,
    meta: {
      title: 'Contact Us | Wetwall',
      description: '',
    }
  },
  {
    path: '/contacts',
    component: Contacts,
    meta: {
      title: 'Contact Us | Wetwall',
      description: '',
    }
  },
  {
    path: '/designs',
    component: Designs,
    meta: {
      title: 'Shower and bathroom panel designs | Wetwall',
      description: 'Whether you are looking for marbles, woodgrains or something different, Wetwall shower panel designs can provide an easy choice into updating your space.',
    }
  },
  {
    path: '/details',
    component: Details,
    meta: {
      title: 'Details | Wetwall',
      description: '',
    }
  },
  {
    path: '/faqs',
    component: FAQs,
    meta: {
      title: 'FAQs | Wetwall',
      description: '',
    }
  },
  {
    path: '/gallery',
    component: Gallery,
    meta: {
      title: 'Gallery | Wetwall',
      description: '',
    }
  },
  {
    path: '/installation',
    component: Installation,
    meta: {
      title: 'Installation Instructions and Resources | Wetwall',
      description: 'Install a refreshed look in 2.5 hours without specialized or dedicated tools. For more information on how to install Wetwall, select the best resource for your installation.',
    }
  },
  {
    path: '/resources',
    component: Resources,
    meta: {
      title: 'Resources, Brochures and More | Wetwall',
      description: 'Looking to install your Wetwall shower panel system?  We have you covered with videos, guides and more to make your installation even easier.',
    }
  },
  {
    path: '/technical-specifications',
    component: TechnicalSpecifications,
    meta: {
      title: 'Technical Specifications | Wetwall',
      description: '',
    }
  },
  {
    path: '/where-to-buy',
    component: WhereToBuy,
    meta: {
      title: 'Buy Online or Find a Store | Wetwall',
      description: 'Wetwall is sold online and in-store through authorized retail partners. Use our Where to Buy locator or find an authorized dealer near you.',
    }
  },
]

const router = new VueRouter({
  routes, // short for `routes: routes`
  mode: 'history',
  //base: "/wilsonart/WIL-0017-Wetwall/"
})

Vue.use(VueGtm, {
  id: 'GTM-N3MZWSN', // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  //debug: true, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  //ignoredViews: ['homepage'] // If router, you can exclude some routes name (case insensitive) (optional)
});

const DEFAULT_TITLE = 'Wetwall';
router.afterEach((to) => {
    // Use next tick to handle router history correctly
    // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
    Vue.nextTick(() => {
        document.title = to.meta.title || DEFAULT_TITLE;
        document.head.querySelector('meta[name=description]').content = to.meta.description || DEFAULT_TITLE;
    });
});

new Vue({
  render: h => h(App),
  router
}).$mount('#app')